var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#78BDA6;fill-opacity:0.15;}\r\n\t.st1{fill:none;stroke:#78BDA6;stroke-width:1.5;stroke-opacity:0.5;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#78BDA6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,2L22,2c11,0,20,9,20,20l0,0c0,11-9,20-20,20l0,0C11,42,2,33,2,22l0,0C2,11,11,2,22,2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22,1.2L22,1.2c11.5,0,20.8,9.3,20.8,20.8l0,0c0,11.5-9.3,20.8-20.8,20.8l0,0C10.5,42.8,1.2,33.5,1.2,22l0,0 C1.2,10.5,10.5,1.2,22,1.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.6,20.2l5.9,8.3c0.1,0.1,0.1,0.2,0.1,0.4c0,0.3-0.3,0.6-0.6,0.6l0,0l0,0l-15.4,0c-0.2,0-0.4-0.1-0.5-0.3 c-0.1-0.2-0.1-0.4,0-0.6L18,23c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0,0.5,0.2l1.6,1.4l2.9-4.2l0-0.9l-3.7,0c-0.3,0-0.6-0.3-0.6-0.6 l0-2.6c0-0.3,0.3-0.6,0.6-0.6l4.3,0c0.3,0,0.6,0.3,0.6,0.6L24.6,20.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsNew);
export default __webpack_public_path__ + "static/media/ms-new.da61544dd43dfde1430873f10b781afa.svg";
export { ForwardRef as ReactComponent };